angular.module("rjmNg.directives").directive "resetPassword", [
  () ->
    restrict: "E"
    templateUrl: "directive.resetPassword.html"
    require: "^?rjmUi"
    scope: {}
    controllerAs: "view"
    bindToController: true
    controller: [
      "$window"
      "$routeParams"
      "$location"
      "$url"
      "notification"
      "Password"
      "Session"
      "Users"
      (
        $window
        $routeParams
        $location
        $url
        notification
        Password
        Session
        Users
      ) ->

        view = @
        view.tosUrl = "https://magento.com/legal/terms"
        view.saving = false
        view.loading = true
        view.tokenIsValid = false
        email = null

        notification.clear "reset-password"

        showNotificationForErrorResponse = (response) ->
          title = "Something went wrong."
          message = "We were unable to verify this password reset token.
            Please try resetting your password again."
          bindHtml = false
          dismissable = false

          if response.status is 403
            resetPasswordUrl = $url("/session/recovery")

            title = "Reset token expired."

            message = "This password reset token is no longer valid. Please try
              <a class='rj-button--link-5' href='#{resetPasswordUrl}'>
              resetting your password
              </a> again."
            bindHtml = true

          else if response.status is 429
            title = "Too many reset requests."
            message = "You have exceeded the number of allowed password reset attempts.
              Please contact support."

          notification.error(title, message, "reset-password", { bindHtml, dismissable })

        view.savePassword = ->
          view.saving = true
          notification.clear "reset-password"

          Users.resetPassword(
            $routeParams.userId
            $routeParams.resetToken
            view.newPassword
          ).then () ->
            Session.create(email, view.newPassword).then (response) ->
              $window.location = response.redirect ? "/"
            .catch () ->
              view.saving = false
              $window.location = $url("/session/create?resetError=true")

          .catch (response) ->
            view.saving = false
            showNotificationForErrorResponse(response)

        @$onInit = () ->
          Password.validate($routeParams.userId, $routeParams.resetToken).then (response) ->
            view.tokenIsValid = true
            email = response.email
          .catch (response) ->
            showNotificationForErrorResponse(response)
          .finally () ->
            view.loading = false

        view
    ]
    link: (scope, element, attributes, rjmUi) ->
      if rjmUi?
        scope.$watchGroup [
          "view.loading"
          "view.saving"
        ], () ->
          rjmUi.blockUi "reset-password", scope.view.loading or scope.view.saving

]
